import { Directive, HostBinding, Input, OnDestroy, OnInit } from '@angular/core';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { FiltersService } from './filters-toolbar/filters.service';
import { ColorSchemeClass } from './theme.const';
import { SettingsService } from './stacking-plan-container/actions-toolbar/settings/settings.service';
import { Settings } from './stacking-plan-container/actions-toolbar/settings/settings.model';
import { merge } from 'rxjs';
import { tap, filter } from 'rxjs/operators';
import { FilterState, FilterView } from './filters-toolbar/filters-toolbar.model';
@UntilDestroy()
@Directive({
  selector: '[spAppTheme]',
  standalone: false,
})
export class ThemeDirective implements OnDestroy, OnInit {
  // tslint:disable-next-line:no-input-rename
  @Input('class')
  @HostBinding('class')
  elementClass: string;
  private currentViewBy: FilterView;
  private currentSettings: Settings;
  private currentClass: ColorSchemeClass;

  // TODO: change FiltersService with SettingsService when available
  constructor(
    private filtersService: FiltersService,
    private settingsService: SettingsService /* settingsService: SettingsService */
  ) {}

  ngOnInit() {
    const filterState$ = this.filtersService.filterState$.pipe(
      filter(filterState => !!filterState),
      tap((filterState: FilterState) => (this.currentViewBy = filterState.viewBy))
    );
    const settings$ = this.settingsService.settings$.pipe(
      filter(settings => !!settings),
      tap((settings: Settings) => (this.currentSettings = settings))
    );

    merge(filterState$, settings$)
      .pipe(untilDestroyed(this))
      .subscribe(() => {
        this.setScheme();
      });
  }

  ngOnDestroy(): void {
    /* required by untilDestroyed */
  }

  private setScheme() {
    if (this.currentViewBy && this.currentSettings) {
      const { expiry, leaseYear, industry, agency, usage, occupier, brand } = this.currentSettings.colorScheme;
      const colorScheme = {
        lease: expiry,
        leaseYear,
        industry,
        agency,
        usage,
        occupier,
        brand,
      };
      const viewColorScheme = colorScheme[this.currentViewBy] || ColorSchemeClass.Schema1;
      let currentElementClasses: string[] = this.elementClass.split(' ');
      currentElementClasses = [...currentElementClasses.filter(klass => klass !== this.currentClass), viewColorScheme];
      this.elementClass = currentElementClasses.join(' ');
      this.currentClass = viewColorScheme;
    }
  }
}
